import { render, staticRenderFns } from "./retailManage.vue?vue&type=template&id=06564c74&scoped=true&"
import script from "./retailManage.vue?vue&type=script&lang=js&"
export * from "./retailManage.vue?vue&type=script&lang=js&"
import style0 from "./retailManage.vue?vue&type=style&index=0&id=06564c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06564c74",
  null
  
)

export default component.exports